/**
 * Tracking form: opens the carrier tracking of the typed number in a new tab, on the address given in `data-url`
 * (`{number}` is replaced with the number). Shows an error message when the field is empty.
 *
 * Markup hooks: a `form` with one `input` and an element with the `role="alert"` attribute (hidden by default).
 */
class TrackOrderForm extends HTMLElement {
  /** @type {AbortController | undefined} */
  #abort;

  connectedCallback() {
    const form = this.querySelector('form');
    const input = this.querySelector('input');
    const error = this.querySelector('[role="alert"]');
    if (!form || !input) return;

    this.#abort = new AbortController();
    const { signal } = this.#abort;

    const showError = (visible) => {
      if (error) error.hidden = !visible;
      input.setAttribute('aria-invalid', visible ? 'true' : 'false');
    };

    form.addEventListener(
      'submit',
      (event) => {
        event.preventDefault();
        const number = input.value.replace(/\s+/g, '').toUpperCase();
        if (!number) {
          showError(true);
          input.focus();
          return;
        }
        showError(false);
        const template = this.dataset.url || '';
        // Only https addresses are opened
        if (!template.startsWith('https://')) return;
        window.open(template.replace('{number}', encodeURIComponent(number)), '_blank', 'noopener');
      },
      { signal }
    );

    input.addEventListener('input', () => showError(false), { signal });
  }

  disconnectedCallback() {
    this.#abort?.abort();
  }
}

if (!customElements.get('track-order-form')) {
  customElements.define('track-order-form', TrackOrderForm);
}
